import React from 'react';
import { Navigate } from 'react-router-dom';
import { useManagerAuth } from '../context/ManagerAuthContext';

const ManagerProtectedRoute = ({ children }) => {
  const { manager, loading } = useManagerAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900">
        <div className="animate-spin w-10 h-10 border-4 border-orange-500 border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!manager) return <Navigate to="/manager/login" replace />;
  return children;
};

export default ManagerProtectedRoute;
